import { IA_KEY } from 'helpers/ia-logic';
import { NAV_KEY } from 'constants/venue-experience';
import { watchColumnActions, PAGE_LAYOUT_VARIANT } from 'features/App';
import { watchActions, handleRouteEnter } from './ManageServices.saga';
import { watchServicesActions } from './Services';
import { handleScheduleIncrementsRouteEnter } from './Services/Services.saga';
import { watchResourcesActions } from './Resources';
import { watchPractitionersActions } from './Practitioners';
import { watchClassListActions } from './ClassList';
import ManageServices from './ManageServicesContainer';
import ScheduleIncrements from './Services/ScheduleIncrements/ScheduleIncrementsContainer';

const commonConfig = {
  component: ManageServices,
  iaKey: IA_KEY.MANAGE_SERVICES,
  navKey: NAV_KEY.SERVICES,
  pathSagas: [
    watchColumnActions,
    watchActions,
    watchServicesActions,
    watchResourcesActions,
    watchPractitionersActions,
    watchClassListActions,
    handleRouteEnter,
  ],
  pageLayout: PAGE_LAYOUT_VARIANT.WIDE,
  hasMultipleColumns: true,
};

/* Tab parameter can be services, resources, or practitioners */
export default [
  {
    path: '/manage/services/:venueId/schedule-increments',
    component: ScheduleIncrements,
    iaKey: IA_KEY.MANAGE_SERVICES,
    navKey: NAV_KEY.SERVICES,
    pathSagas: [
      watchColumnActions,
      watchActions,
      watchServicesActions,
      handleRouteEnter,
      handleScheduleIncrementsRouteEnter,
    ],
    pageLayout: PAGE_LAYOUT_VARIANT.WIDE,
  },
  {
    path: '/manage/services/:venueId/:tab/add',
    ...commonConfig,
  },
  {
    path: '/manage/services/:venueId/:tab/:itemId/edit',
    ...commonConfig,
  },
  {
    path: '/manage/services/:venueId/:tab/:itemId?',
    ...commonConfig,
  },
];
